import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationService } from 'src/app/i18n/translation.service';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckboxComponent {
  @Input() showChild: boolean = false;
  @Input() customClass: string = '';
  lang: string = 'en';
  @Input() isErrorEnabled: boolean = false;
  @Input() data: any = {//remove it once you chane it everywhere
    title: 'SHOP.LIMITED_HOURS',
    name: 'limitedHours',
    value: false
  };
  @Output() onChange: EventEmitter<boolean> = new EventEmitter();
  private routerEventsSubscription: Subscription;
  constructor(
    private translationService: TranslationService,
    private router: Router,    
  ) {
    this.lang = this.translationService.getSelectedLanguage();
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.lang = this.translationService.getSelectedLanguage();        
      }
    });
  }

  change() {
    this.onChange.emit(this.data.value);
  }

}
